import baseURLv1 from '@/services/APIConfig.js';
import { set } from '@/vuex/helpers';

export default {
  namespaced: true,
  state: {
    isLoading: false,
    logs: [],
    filters: {
      order_by: '-date',
      action_user: '',
      action_name: '',
      severity: '',
      action_date_from: '',
      action_date_to: '',
      page: 1,
      page_size: 10,
    },
    previous: null,
    next: null,
  },
  mutations: {
    set,
    updateFilter(state, { field, payload }) {
      state.filters[field] = payload;
      if (field !== 'page') {
        state.filters.page = 1;
      }
    },
  },
  actions: {
    async load({ state, commit }) {
      commit('set', ['isLoading', true]);
      const response = await this.$axios.get(`${baseURLv1}/audit/log/administration/`, {
        params: {
          ...state.filters,
        },
      });

      commit('set', ['logs', response.data.data]);
      commit('set', ['previous', response.data.previous]);
      commit('set', ['next', response.data.next]);
      commit('set', ['isLoading', false]);
    },
  },
};
